module.exports = __webpack_public_path__ + "img/times-square.219ba259.jpeg";